"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_validator_1 = require("class-validator");
const ActionIDs_1 = require("./enums/ActionIDs");
class OrchestratorBody extends base_models_1.Serializable {
}
exports.default = OrchestratorBody;
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsEnum)(ActionIDs_1.ActionIDs),
    (0, base_models_1.Docs)({ example: ActionIDs_1.ActionIDs.ProcessCustomerConfirmation, description: 'what action to execute' }),
    tslib_1.__metadata("design:type", String)
], OrchestratorBody.prototype, "actionID", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsObject)(),
    (0, base_models_1.Docs)({ example: {}, description: 'BPM Case data in View mode' }),
    tslib_1.__metadata("design:type", Object)
], OrchestratorBody.prototype, "caseData", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsObject)(),
    (0, class_validator_1.IsOptional)(),
    (0, base_models_1.Docs)({ example: { BusinessAgreementID: '12345' }, description: 'additional data' }),
    tslib_1.__metadata("design:type", Object)
], OrchestratorBody.prototype, "additionalData", void 0);
